module.exports = __webpack_public_path__ + "static/media/3h_website_logo_coorg_cyberport.a99eeeff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/3h_website_logo_coorg_cyberport.jpg
// module id = 48
// module chunks = 0